import type { OverlayApi } from '@hibro/shared';
import { createContext, useContext } from 'react';

/**
 * OverlaySurface opener API context (架构方案 §5.8). Provided by the
 * `OverlayProvider` at the workbench root and consumed by every inline-dom view
 * (via `surface-host` → `ViewProps.overlay`) so a view can open modals/drawers/
 * confirms in-process. Split into its own module so `surface-host` can read it
 * without importing `overlay-host` (which itself imports `SurfaceView`), avoiding
 * an import cycle. Outside a provider (e.g. a detached window) the default no-ops.
 */
export const NOOP_OVERLAY_API: OverlayApi = {
  openModal: () => Promise.resolve(undefined),
  openDrawer: () => Promise.resolve(undefined),
  openPopover: () => Promise.resolve(undefined),
  confirm: () => Promise.resolve(false),
  alert: () => Promise.resolve(),
  prompt: () => Promise.resolve(null),
  select: () => Promise.resolve(null),
};

export const OverlayContext = createContext<OverlayApi>(NOOP_OVERLAY_API);

/** Read the OverlaySurface opener API (no-ops when no provider is mounted). */
export function useOverlay(): OverlayApi {
  return useContext(OverlayContext);
}
